import { defineComponent as _defineComponent } from 'vue'
import { reactive, toRefs, computed } from "vue";
import CommonProps from "./Props/CommonProps";
import { turno } from "@/core/listas/turnoList";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabelaInput',
  props: CommonProps,
  emits: ["dadosTabela"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const { dataListTable, customProps, nomeEnsino } = toRefs(props);

const emit = __emit;

const body = computed(() => {
  const bodyTable = setBodyTable(dataListTable.value);
  return bodyTable;
});

const header = computed(() => {
  const headerTable = setHeaderTable(dataListTable.value);
  const filteredArray: any = multiDimensionalUnique(headerTable);
  return filteredArray.sort((a, b) => {
    return ("" + a.turno).localeCompare(b.turno);
  });
});

function multiDimensionalUnique(headerTable: any) {
  var arrayDeValoresUnicos = [] as any;
  var itemAchado = {};
  for (var i = 0, l = headerTable.length; i < l; i++) {
    var stringified = JSON.stringify(headerTable[i].turno);
    if (itemAchado[stringified]) {
      continue;
    }
    arrayDeValoresUnicos.push(headerTable[i]);
    itemAchado[stringified] = true;
  }
  return arrayDeValoresUnicos;
}

const data = reactive({
  form: {
    input: [] as any,
  },
});

function setDadosTabela(event) {
  const convertedData = converterDadosParaEnviar(data.form);
  emit("dadosTabela", convertedData, event.target);
}

function converterDadosParaEnviar(dados) {
  const dataToSendToBack = [] as any[];
  for (const key in dados.input) {
    const dadosConvertidos = key.split("_");
    dataToSendToBack.push({
      id: dadosConvertidos[1],
      value: dados.input[key],
    });
  }
  return dataToSendToBack;
}

function setHeaderTable(dadosDoBanco) {
  return dadosDoBanco.map((e) => {
    return {
      turno: e.fase,
    };
  });
}

function setBodyTable(dadosDoBanco) {
  const dadosDoBancoMapeados = dadosDoBanco.map((e) => {
    return e.turno;
  });
  const dadosProntosParaOComponent = mapearInputsDaTabela(
    dadosDoBancoMapeados,
    dadosDoBanco
  );
  gerarDataReativaDinamica(dadosProntosParaOComponent);
  return dadosProntosParaOComponent;
}

function gerarDataReativaDinamica(dadosDoBancoMapeados) {
  for (const dados of dadosDoBancoMapeados) {
    for (const valor of dados.values) {
      data.form.input[`id_${valor.id}`] = valor[customProps.value];
    }
  }
}

function mapearInputsDaTabela(dadosDoBancoMapeados, dadosDoBanco) {
  const filteredArray = dadosDoBancoMapeados.filter(
    (data, index) => dadosDoBancoMapeados.indexOf(data) === index
  );
  return filteredArray.map((turnoFiltered) => {
    let filteredData = dadosDoBanco.filter((bodyTurno) => {
      return bodyTurno.turno === turnoFiltered;
    });
    let returnTitle = "";
    if (typeof turnoFiltered == "string") {
      returnTitle = turno.filter((e) => e.label == turnoFiltered)[0].label;
    } else {
      returnTitle = turno.filter((e) => e.value == turnoFiltered)[0].label;
    }
    return {
      title: returnTitle,
      values: [...filteredData],
    };
  });
}

const { form } = toRefs(data);

const __returned__ = { props, dataListTable, customProps, nomeEnsino, emit, body, header, multiDimensionalUnique, data, setDadosTabela, converterDadosParaEnviar, setHeaderTable, setBodyTable, gerarDataReativaDinamica, mapearInputsDaTabela, form, get turno() { return turno } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})